export default {
  endpoints: {
    stitchBackend: "https://api.staging.withstitch.com",
    astraRedirect: "https://onboarding.staging.withstitch.com",
  },
  debug: false,
};
